import {
  Box,
  Button,
  Heading,
  HStack,
  Image,
  SimpleGrid,
  Text,
  VStack,
} from '@chakra-ui/react'
import { Link } from 'react-router-dom'

import assets from '@/assets'

export default function Component() {
  return (
    <Box position="relative" h="full">
      <Box
        px={8}
        py={4}
        borderBottom="1px solid"
        borderBottomColor="gray.300"
        bg="gray.100"
        zIndex={10}
      >
        <HStack justifyContent="flex-end">
          <Link to="/entrar">
            <Button colorScheme="primary">Área do usuário</Button>
          </Link>
        </HStack>
      </Box>

      <SimpleGrid minChildWidth={300} gap={8} p={8}>
        <Box>
          <Box mb={8}>
            <Heading fontWeight="light">Bem-vindo</Heading>
            <Text fontSize="lg">ao sistema interno da Multitec</Text>
          </Box>

          <Text fontSize="lg">
            Aqui você tem acesso aos seus equipamentos, chamados, relatórios e
            muito mais.
          </Text>
        </Box>

        <VStack align="stretch" gap={8}>
          <Image src={assets.logo} h="300px" objectFit="contain" />

          <Link to="/entrar-externo">
            <Button colorScheme="primary" py={6} w="100%">
              Já sou cliente Multitec
            </Button>
          </Link>

          <a
            href="https://multitecequipamentos.com.br/"
            target="_blank"
            rel="noreferrer"
          >
            <Button py={6} w="100%">
              Quero me tornar um cliente Multitec
            </Button>
          </a>
        </VStack>
      </SimpleGrid>

      <Image
        src={assets.logo2}
        position="absolute"
        bottom={-24}
        left={-24}
        h="600px"
        w="600px"
        minW="600px"
        zIndex={-1}
        filter="brightness(2) hue-rotate(-40deg)"
        opacity={0.05}
      />
    </Box>
  )
}
